import React from 'react';

import { Timeline } from 'antd';
import moment from 'moment';
import { T } from 'react-translator-component';

import { CommentTimestamp, FieldValue } from './styled';

// Os tipos do antd 4.10 com @types/react 18 nao declaram `children` em Timeline.
const AntTimeline = Timeline as React.FC<React.ComponentProps<typeof Timeline> & { children?: React.ReactNode }>;
const AntTimelineItem = Timeline.Item as React.FC<
  React.ComponentProps<typeof Timeline.Item> & { children?: React.ReactNode }
>;

// Marcador de filho gravado pelo backend num campo do Jira: `tenant:<pk>:<nome>`.
const CHILD_MARKER = /^tenant:\d+:/;

export const formatDate = (iso: string | null): string => {
  if (!iso) return '';
  const parsed = moment(iso, moment.ISO_8601, true);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY HH:mm') : '';
};

interface FieldsProps {
  fields: Record<string, string> | null | undefined;
  fieldLabels?: Record<string, string> | null;
  childTenantName?: string | null;
}

/**
 * Campos do chamado como texto React (nunca HTML). Rotulo = fieldLabels[id] ?? id; vazios saem;
 * `customfield_*` sem rotulo nunca aparece (id cru); o marcador de filho so aparece como
 * "Aberto em nome de <nome>", com o nome que a pagina ja conhece (childTenantName do resumo).
 */
export const TicketFields = ({ fields, fieldLabels, childTenantName }: FieldsProps) => {
  const rows: React.ReactNode[] = [];
  Object.entries(fields ?? {}).forEach(([id, value]) => {
    if (value == null || String(value).trim() === '') return;
    const text = String(value);
    if (CHILD_MARKER.test(text.trim())) {
      if (childTenantName) {
        rows.push(
          <p key={id}>
            {T('Opened on behalf of')} {childTenantName}
          </p>,
        );
      }
      return;
    }
    const label = fieldLabels?.[id];
    if (!label && id.startsWith('customfield_')) return;
    rows.push(
      <FieldValue key={id}>
        <strong>{label || id}:</strong> {text}
      </FieldValue>,
    );
  });
  return <>{rows}</>;
};

export const TicketHistory = ({ history }: { history: string[] | null | undefined }) => (
  <>
    <h4>{T('History')}</h4>
    <AntTimeline>
      {(history ?? []).map((h, i) => (
        <AntTimelineItem key={`${i}-${h}`}>{h}</AntTimelineItem>
      ))}
    </AntTimeline>
  </>
);

export const CommentDate = ({ iso }: { iso: string | null }) => {
  const text = formatDate(iso);
  return text ? <CommentTimestamp>{text}</CommentTimestamp> : null;
};
